module.exports = __webpack_public_path__ + "static/media/logo_wbs_akademie.0f875759.svg";